<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">BILLS WITHOUT COLLECTORS</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">Unassigned Bills</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary Card -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card bg-info text-white">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-8">
                        <h5 class="text-white mb-1">Bills Requiring Collector Assignment</h5>
                        <h2 class="text-white mb-0">{{ totalDetailAmount }}</h2>
                        <small class="text-white opacity-75">Bills without assigned collectors</small>
                      </div>
                      <div class="col-4 text-end">
                        <div class="badge bg-light text-info fs-6 px-3 py-2">
                          {{ billDetails.length }} Unassigned Bills
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main content -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <!-- Header -->
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">
                        <i class="mdi mdi-account-question me-2 text-info"></i>
                        Bills Without Collectors
                      </h4>
                      <div>
                        <a v-if="getRight('CREATE BILL')" @click="gotTo('new-bill')"
                           class="btn btn-primary" type="button">
                          <i class="mdi mdi-plus-circle-outline font-size-16"></i>
                          <span class="d-md-inline ms-1">Create A Bill</span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <!-- Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-center">
                      <!-- Revenue Stream Filter -->
                      <div class="col-md-3">
                        <label class="form-label mb-1">Revenue Stream:</label>
                        <select @change="filterByStream($event)" class="form-select">
                          <option value="">All Streams</option>
                          <option v-for="stream in streams" :key="stream.id" :value="stream.incomeTypePrefix">
                            {{ stream.name }}
                          </option>
                        </select>
                      </div>

                      <!-- Search -->
                      <div class="col-md-9">
                        <label class="form-label mb-1">Search:</label>
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control"
                                 placeholder="Search bills, descriptions, customers...">
                          <i class="bx bx-search-alt position-absolute top-50 end-0 translate-middle-y me-3"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Location and Date Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-end">
                      <!-- Location Filters -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Sub County:</label>
                        <select class="form-select" v-model="subCounty" @change="getBillsPaginate()">
                          <option value="">All Sub Counties</option>
                          <option v-for="item in subCounties" :key="item.subCountyID" :value="item">
                            {{ item.subCountyName }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">Ward:</label>
                        <select class="form-select" v-model="ward" @change="getZones(ward.wardID, ward.wardName)">
                          <option value="">All Wards</option>
                          <option v-for="item in wards" :key="item.wardID" :value="item">
                            {{ item.wardName }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">Zone:</label>
                        <select class="form-select" v-model="zone" @change="getUsers(zone)">
                          <option value="">All Zones</option>
                          <option v-for="item in zones" :key="item.zone" :value="item.zone">
                            {{ item.zone }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">Attendant:</label>
                        <select class="form-select" v-model="selectedUser" @change="getBillsPaginate()">
                          <option value="">All Attendants</option>
                          <option v-for="item in users" :key="item.idNo" :value="item.idNo">
                            {{ item.names }}
                          </option>
                        </select>
                      </div>

                      <!-- Date Filters -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">From:</label>
                        <input v-model="dateFrom" class="form-control" type="date">
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">To:</label>
                        <input v-model="dateTo" class="form-control" type="date">
                      </div>
                    </div>

                    <!-- Download Button -->
                    <div class="mt-3">
                      <button v-if="getRight('DOWNLOAD INVOICE WITH NO COLLECTORS')" @click="downloadBillsPaginate()"
                              type="button" class="btn btn-info">
                        <i class="bx bxs-download font-size-16"></i>
                        <span class="ms-1">{{ download }}</span>
                      </button>
                    </div>
                  </div>

                  <!-- Table -->
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-info">
                        <tr>
                          <th class="text-nowrap">NO.</th>
                          <th class="text-nowrap">Bill No</th>
                          <th class="text-nowrap" style="min-width: 200px;">Description</th>
                          <th class="text-nowrap">Location</th>
                          <th class="text-nowrap">Current Attendant</th>
                          <th class="text-nowrap text-end">Billed Amount</th>
                          <th class="text-nowrap text-end">Amount Paid</th>
                          <th class="text-nowrap text-end">Balance</th>
                          <th class="text-nowrap">Status</th>
                          <th class="text-nowrap">Date</th>
                          <th class="text-nowrap">Receipted By</th>
                          <th class="text-nowrap">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in billDetails" :key="index">
                          <td class="text-nowrap">{{ index + 1 }}</td>
                          <td class="text-nowrap">
                            <a href="javascript:void(0)" @click="dismissBill(item.billNo)"
                               class="text-decoration-none fw-semibold text-info">
                              {{ item.billNo }}
                            </a>
                          </td>
                          <td style="min-width: 200px;">
                            <div>
                              <strong>{{ item.description }}</strong>
                              <small class="text-muted d-block">({{ item.incomeTypeDescription }})</small>
                              <small class="text-muted d-block">{{ item.feeDescription }}</small>
                              <small class="text-muted d-block">{{ maskPhoneNumber(item.customers) }}</small>
                              <div class="mt-1">
                                    <span class="badge bg-info text-white">
                                      <i class="mdi mdi-account-question me-1"></i>NO COLLECTOR
                                    </span>
                              </div>
                            </div>
                          </td>
                          <td class="text-nowrap">
                            <div>
                              <div>{{ item.subCountyName }}</div>
                              <small class="text-muted">{{ item.wardName }}</small>
                              <small class="text-muted d-block">{{ item.zone }}</small>
                            </div>
                          </td>
                          <td class="text-nowrap">{{ item.names || 'Not Assigned' }}</td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold">{{ formatPrice(item.detailAmount) }}</span>
                          </td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold">{{ formatPrice(item.receiptAmount) }}</span>
                          </td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold">{{ formatPrice(item.billBalance) }}</span>
                          </td>
                          <td>
                                <span v-if="item.status === 'PAID'"
                                      class="badge bg-success text-uppercase"
                                      @click="invalidatePayment(item.billNo)"
                                      style="cursor: pointer;">
                                  {{ item.status }}
                                </span>
                            <span v-else class="badge bg-danger text-uppercase">
                                  UNPAID
                                </span>
                          </td>
                          <td class="text-nowrap">{{ item.dateCreated }}</td>
                          <td class="text-nowrap">{{ item.receiptedBy || 'Not Assigned' }}</td>
                          <td class="text-nowrap">
                            <div class="d-flex">
                              <button @click="getBill(item.billNo)"
                                      class="btn btn-outline-info btn-sm me-2"
                                      data-bs-toggle="modal"
                                      data-bs-target="#billDetailModal">
                                <i class="bx bx-show me-1"></i>View
                              </button>
                              <button v-if="getRight('MAP INVOICE TO COLLECTOR')"
                                      @click="openCollectorUpdateModal(item)"
                                      class="btn btn-info btn-sm"
                                      data-bs-toggle="modal"
                                      data-bs-target="#collectorAssignmentModal">
                                <i class="mdi mdi-account-plus me-1"></i>Assign
                              </button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot class="table-info">
                        <tr>
                          <th colspan="5" class="text-end">{{ billDetails.length }} Unassigned Bills</th>
                          <th class="text-end">{{ totalDetailAmount }}</th>
                          <th class="text-end">{{ totalReceiptAmount }}</th>
                          <th class="text-end">{{ totalBillBalance }}</th>
                          <th colspan="4"></th>
                        </tr>
                        </tfoot>
                      </table>

                      <!-- Loading State -->
                      <div v-if="loading" class="text-center p-5">
                        <div class="spinner-border text-info mb-3" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <h4>Loading Bills</h4>
                        <p>We are fetching bills without assigned collectors. Please wait...</p>
                      </div>

                      <!-- No Results -->
                      <div v-if="billDetails.length < 1 && !loading" class="text-center p-5">
                        <img :src="'./assets/images/no-results.png'" class="img-fluid mb-4" alt="No results" style="max-width: 200px;">
                        <h4>No Unassigned Bills Found</h4>
                        <p>Great! All bills have collectors assigned or no bills match your search criteria.</p>
                      </div>
                    </div>
                  </div>

                  <!-- Pagination -->
                  <div class="card-footer bg-white">
                    <nav class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <span class="me-3">Rows Per Page</span>
                        <select class="form-select w-auto" v-model="pageSize">
                          <option value="10">10 Rows</option>
                          <option value="25">25 Rows</option>
                          <option value="50">50 Rows</option>
                          <option value="100">100 Rows</option>
                          <option value="150">150 Rows</option>
                          <option value="200">200 Rows</option>
                          <option value="500">500 Rows</option>
                          <option value="1000">1000 Rows</option>
                        </select>
                      </div>

                      <ul class="pagination mb-0">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <button class="page-link" @click="prevPage" :disabled="currentPage === 1">Previous</button>
                        </li>
                        <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page"
                            class="page-item" :class="{ active: currentPage === page }">
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <button v-else class="page-link" @click="goToPage(page)">{{ page }}</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <button class="page-link" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Reuse Bill Detail Modal -->
        <BillDetailModal
            :billDetail="billDetail"
            :billInfo="billInfo"
            :billNo="billNo"
            @print-bill="printBill"
        />

        <!-- Collector Assignment Modal -->
        <CollectorAssignmentModal
            :selectedBillNo="selectedBillNo"
            :selectedBillIncomeTypeDescription="selectedBillIncomeTypeDescription"
            @collector-assigned="handleCollectorAssigned"
        />

        <!-- Alert for actions -->
        <div v-if="alert.success || alert.failed || alert.info" class="toast-container position-fixed top-0 end-0 p-3">
          <div class="toast show" role="alert">
            <div class="toast-header" :class="{
                'bg-success text-white': alert.success,
                'bg-danger text-white': alert.failed,
                'bg-info text-white': alert.info
              }">
              <strong class="me-auto">Notification</strong>
              <button type="button" class="btn-close" @click="clearAlerts"></button>
            </div>
            <div class="toast-body">
              {{ message }}
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, executeDownload, getRight } from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import BillDetailModal from "@/components/invoices/modals/BillDetailModal.vue";
import CollectorAssignmentModal from "@/components/invoices/modals/CollectorAssignmentModal.vue";
import router from "@/router";
import moment from "moment";

export default {
  name: "BillsWithoutCollectors",
  components: {
    NavigationBar,
    BillDetailModal,
    CollectorAssignmentModal
  },
  data() {
    return {
      download: 'Download',
      search: '',
      loading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,

      // Filters
      dateFrom: '',
      dateTo: '',
      selectedStream: '',

      // Data
      billDetails: [],
      billInfo: [],
      billDetail: {},
      billNo: '',

      // Location data
      subCounties: [],
      wards: [],
      zones: [],
      users: [],
      subCounty: '',
      ward: '',
      zone: '',
      selectedUser: '',

      // Revenue streams
      streams: [],

      // Modal data
      selectedBillNo: '',
      selectedBillIncomeTypeDescription: '',

      // Summary
      summary: { count: 0, total: 0 },

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    }
  },
  computed: {
    totalReceiptAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, item) => sum + parseInt(item.receiptAmount || 0), 0));
    },
    totalBillBalance() {
      return this.formatPrice(this.billDetails.reduce((sum, item) => sum + parseInt(item.billBalance || 0), 0));
    },
    totalDetailAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, item) => sum + parseInt(item.detailAmount || 0), 0));
    }
  },
  watch: {
    pageSize() {
      this.getBillsPaginate();
      this.totalPages = Math.ceil(this.summary.count / this.pageSize);
      this.currentPage = 1;
    },
    search() {
      this.getBillsPaginate();
    },
    subCounty() {
      this.getWards();
      this.getBillsPaginate();
    },
    ward() {
      this.getBillsPaginate();
    },
    dateFrom() {
      if (this.dateFrom && this.dateTo) {
        this.getBillsPaginate();
      }
    },
    dateTo() {
      if (this.dateFrom && this.dateTo) {
        this.getBillsPaginate();
      }
    }
  },
  mounted() {
    this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');

    this.getAvailableStreams();
    this.getSubCounties();
    this.getBillsPaginate();
    this.menuAccess();
  },
  methods: {
    getRight,

    // Utility methods
    formatPrice(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value);
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') return input;
      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }
      return input;
    },

    gotTo(route) {
      router.push(route);
    },

    clearAlerts() {
      this.alert = { success: false, info: false, failed: false };
      this.message = '';
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      // Auto clear after 5 seconds
      setTimeout(() => {
        this.clearAlerts();
      }, 5000);
    },

    // API methods
    async getAvailableStreams() {
      try {
        const data = new FormData();
        data.append("function", "getAvailableStreams");

        const res = await execute(data, biller);
        if (res.data.success) {
          this.streams = res.data.data.streams;
        } else {
          this.message = res.data.message;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    filterByStream(event) {
      this.selectedStream = event.target.value;
      this.getBillsPaginate();
    },

    async getBillsPaginate() {
      try {
        this.billDetails = [];
        this.loading = true;

        const data = new FormData();
        data.append("function", "getBillWithNoCollectors");
        data.append("page", this.currentPage);
        data.append("rows_per_page", this.pageSize);
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("keyword", this.search);
        data.append("subCountyID", this.subCounty?.subCountyID || '');
        data.append("wardID", this.ward?.wardID || '');
        data.append("zone", this.zone);
        data.append("idNo", this.selectedUser);
        data.append("incomeTypePrefix", this.selectedStream);

        const res = await execute(data, biller);
        this.loading = false;

        if (res.data.success) {
          this.billDetails = res.data.data.billDetails;
          this.summary = res.data.data.summary;
          this.totalPages = Math.ceil(this.summary.count / this.pageSize);
        } else {
          this.message = res.data.message;
        }
      } catch (e) {
        this.loading = false;
        this.message = e.message;
      }
    },

    async downloadBillsPaginate() {
      try {
        this.download = "Please wait...";

        const data = new FormData();
        data.append("function", "downloadBillsPaginate");
        data.append("page", this.currentPage);
        data.append("rows_per_page", this.pageSize);
        data.append("status", "UNPAID");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("keyword", this.search);
        data.append("subCountyID", this.subCounty?.subCountyID || '');
        data.append("wardID", this.ward?.wardID || '');
        data.append("zone", this.zone);
        data.append("idNo", this.selectedUser);
        data.append("incomeTypePrefix", this.selectedStream);

        const response = await executeDownload(data, biller);
        this.download = "Download Report";

        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = `${this.dateFrom} to ${this.dateTo} Unassigned Bills Report.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (e) {
        this.download = "Download Report";
        this.message = e.message;
      }
    },

    async dismissBill(billNo) {
      if (sessionStorage.getItem("statusCode") === "2") {
        const isConfirmed = confirm("Are you sure you want to dismiss this bill?");
        if (!isConfirmed) return;

        try {
          const data = new FormData();
          data.append("function", "dismissBill");
          data.append("billNo", billNo);

          const res = await execute(data, biller);
          if (res.data.success) {
            this.showAlert('success', res.data.message);
            this.getBillsPaginate();
          } else {
            this.showAlert('failed', res.data.message);
          }
        } catch (e) {
          this.showAlert('failed', e.message);
        }
      }
    },

    async invalidatePayment(billNo) {
      if (sessionStorage.getItem("statusCode") === "2") {
        const isConfirmed = confirm("Are you sure you want to invalidate this payment?");
        if (!isConfirmed) return;

        try {
          const data = new FormData();
          data.append("function", "invalidatePayment");
          data.append("billNo", billNo);

          const res = await execute(data, biller);
          if (res.data.success) {
            this.showAlert('success', res.data.message);
            this.getBillsPaginate();
          } else {
            this.showAlert('failed', res.data.message);
          }
        } catch (e) {
          this.showAlert('failed', e.message);
        }
      }
    },

    async getBill(billNo) {
      try {
        this.billNo = billNo;

        const data = new FormData();
        data.append("function", "getBill");
        data.append("billNo", billNo);

        const res = await execute(data, biller);
        if (res.data.success) {
          this.billInfo = res.data.data.billInfo;
          this.billDetail = res.data.data.billDetails;
        } else {
          this.message = res.data.message;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    printBill() {
      localStorage['params'] = JSON.stringify({
        billNo: this.billDetail.billNo
      });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    openCollectorUpdateModal(item) {
      this.selectedBillNo = item.billNo;
      this.selectedBillIncomeTypeDescription = item.incomeTypeDescription;

      // Use Vue's nextTick to ensure the data is set before showing the modal
      this.$nextTick(() => {
        const modalElement = document.getElementById('collectorAssignmentModal');
        if (modalElement) {
          const modal = new bootstrap.Modal(modalElement);
          modal.show();
        }
      });
    },

    handleCollectorAssigned(data) {
      this.showAlert('success', 'Collector assigned successfully!');
      this.getBillsPaginate();
    },

    async getSubCounties() {
      try {
        const data = new FormData();
        data.append("function", "getSubCounty");

        const res = await execute(data, biller);
        if (res.data.success) {
          this.subCounties = res.data.data.subCounties;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    async getWards() {
      try {
        this.wards = [];
        this.ward = '';

        if (!this.subCounty?.subCountyID) return;

        const data = new FormData();
        data.append("function", "getWards");
        data.append("subCountyID", this.subCounty.subCountyID);

        const res = await execute(data, biller);
        if (res.data.success) {
          this.wards = res.data.data.wards;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    async getZones(wardID, wardName) {
      try {
        this.zones = [];

        if (wardName) {
          this.getBillsPaginate();
        }

        if (!wardID) return;

        const data = new FormData();
        data.append("function", "getZones");
        data.append("wardID", wardID);

        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.zones = res.data.data.zones;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    async getUsers(zone) {
      try {
        this.users = [];

        if (zone) {
          this.getBillsPaginate();
        }

        const data = new FormData();
        data.append("function", "getUsers");
        data.append("search", zone || '');

        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.users = res.data.data.users;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Bills Without Collectors");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    },

    // Pagination methods
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getBillsPaginate();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getBillsPaginate();
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getBillsPaginate();
      }
    }
  }
}
</script>

<style scoped>
.table th {
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  vertical-align: middle;
}

.form-label {
  font-weight: 600;
  font-size: 0.875rem;
}

.badge {
  font-size: 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.card-header {
  padding: 1rem;
}

.toast-container {
  z-index: 9999;
}

.text-info {
  color: #0dcaf0 !important;
}

.bg-info {
  background: linear-gradient(135deg, #17a2b8 0%, #0dcaf0 100%);
}

.table-info {
  background-color: rgba(13, 202, 240, 0.1);
}

.table-info th {
  background-color: rgba(13, 202, 240, 0.2) !important;
  color: #055160;
  font-weight: 600;
}

.text-decoration-none:hover {
  text-decoration: underline !important;
}
</style>